export const PEOPLE_TABS = {
  ATTENDEES: "attendees",
  COHOSTS: "cohosts",
};

export type PeopleTab = (typeof PEOPLE_TABS)[keyof typeof PEOPLE_TABS];

export const SCROLLABLE_TARGET_ID = "live-form-modal-body";

export const DETAILS_SECTION_INDEX = 2;
